import translationEn from "@/assets/locales/en/translation.json";
import translationVi from "@/assets/locales/vi/translation.json";
import translationHi from "@/assets/locales/in/translation.json";
import headerEn from "@/assets/locales/en/header.json";
import headerVi from "@/assets/locales/vi/header.json";
import headerHi from "@/assets/locales/in/header.json";
import commonEn from "@/assets/locales/en/common.json";
import commonVi from "@/assets/locales/vi/common.json";
import commonHi from "@/assets/locales/in/common.json";
import commonAr from "@/assets/locales/ar/common.json";
import commonEs from "@/assets/locales/es/common.json";
import headerAr from "@/assets/locales/ar/header.json";
import headerEs from "@/assets/locales/es/header.json";

import apiAdhocTestingEn from "@/assets/locales/en/apiAdhocTesting.json";
import apiAdhocTestingVi from "@/assets/locales/vi/apiAdhocTesting.json";
import apiAdhocTestingHi from "@/assets/locales/in/apiAdhocTesting.json";
import apiAdhocTestingAr from "@/assets/locales/ar/apiAdhocTesting.json";
import apiAdhocTestingEs from "@/assets/locales/es/apiAdhocTesting.json";

import messageEn from "@/assets/locales/en/message.json";
import messageVi from "@/assets/locales/vi/message.json";
import messageHi from "@/assets/locales/in/message.json";
import sidebarEn from "@/assets/locales/en/sidebar.json";
import sidebarVi from "@/assets/locales/vi/sidebar.json";
import sidebarHi from "@/assets/locales/in/sidebar.json";

import mockServerEn from "@/assets/locales/en/mockServer.json";
import mockServerHi from "@/assets/locales/in/mockServer.json";
import mockServerVi from "@/assets/locales/vi/mockServer.json";

import apiFormEn from "@/assets/locales/en/apiForm.json";
import apiFormVi from "@/assets/locales/vi/apiForm.json";
import apiFormHi from "@/assets/locales/in/apiForm.json";

import commentsEn from "@/assets/locales/en/comments.json";
import commentsVi from "@/assets/locales/vi/comments.json";
import commentsHi from "@/assets/locales/in/comments.json";

import monitoringEn from "@/assets/locales/en/monitoring.json";
import monitoringVi from "@/assets/locales/vi/monitoring.json";
import monitoringHi from "@/assets/locales/in/monitoring.json";

import teamsEn from "@/assets/locales/en/teams.json";
import teamsVi from "@/assets/locales/vi/teams.json";
import teamsHi from "@/assets/locales/in/teams.json";

import workspaceEn from "@/assets/locales/en/workspace.json";
import workspaceVi from "@/assets/locales/vi/workspace.json";
import workspaceHi from "@/assets/locales/in/workspace.json";

import workSpaceDardboardEn from "@/assets/locales/en/workSpaceDardboard.json";
import workSpaceDardboardVi from "@/assets/locales/vi/workSpaceDardboard.json";
import workSpaceDardboardHi from "@/assets/locales/in/workSpaceDardboard.json";

import apiGovernanceEn from "@/assets/locales/en/apiGovernance.json";
import apiGovernanceVi from "@/assets/locales/vi/apiGovernance.json";
import apiGovernanceHi from "@/assets/locales/in/apiGovernance.json";
import apiGovernanceAr from "@/assets/locales/ar/apiGovernance.json";
import apiGovernanceEs from "@/assets/locales/es/apiGovernance.json";

import ruleMgmtEn from "@/assets/locales/en/ruleMgmt.json";
import ruleMgmtVi from "@/assets/locales/vi/ruleMgmt.json";
import ruleMgmtHi from "@/assets/locales/in/ruleMgmt.json";

import companyMgmtEn from "@/assets/locales/en/companyMgmt.json";
import companyMgmtVi from "@/assets/locales/vi/companyMgmt.json";
import companyMgmtHi from "@/assets/locales/in/companyMgmt.json";
import companyMgmtAr from "@/assets/locales/ar/companyMgmt.json";
import companyMgmtEs from "@/assets/locales/es/companyMgmt.json";

import apiApplicationEn from "@/assets/locales/en/apiApplication.json";
import apiApplicationVi from "@/assets/locales/vi/apiApplication.json";
import apiApplicationHi from "@/assets/locales/in/apiApplication.json";

import datahubNewEn from "@/assets/locales/en/datahubNew.json";
import datahubNewVi from "@/assets/locales/vi/datahubNew.json";
import datahubNewHi from "@/assets/locales/in/datahubNew.json";

import PIIEn from "@/assets/locales/en/PII.json";
import PIIVi from "@/assets/locales/vi/PII.json";
import PIIHi from "@/assets/locales/in/PII.json";
import PIIAr from "@/assets/locales/ar/PII.json";
import PIIEs from "@/assets/locales/es/PII.json";

import bugherdEn from "@/assets/locales/en/bugherd.json";
import bugherdVi from "@/assets/locales/vi/bugherd.json";
import bugherdHi from "@/assets/locales/in/bugherd.json";
import bugherdAr from "@/assets/locales/ar/bugherd.json";
import bugherdEs from "@/assets/locales/es/bugherd.json";

import { MULTI_LANGUAGE } from "@/utils/Constant";
import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const defaultNS = "translation";

const ns = [
  "common",
  "datahub",
  "translation",
  "teams",
  "workspace",
  "workSpaceDardboard",
  "header",
  "workSpaceTabs",
  "workSpaceRightSideBar",
  "workSpaceContentDashboard",
  "message",
  "sidebar",
  "apiGovernance",
  "apiAdhocTesting",
  "ruleMgmt",
  "mockServer",
  "companyMgmt",
  "apiApplication",
  "datahubNew",
  "apiForm",
  "comments",
  "monitoring",
  "PII",
];

const resources = {
  en: {
    translation: translationEn,
    common: commonEn,
    teams: teamsEn,
    workspace: workspaceEn,
    workSpaceDardboard: workSpaceDardboardEn,
    header: headerEn,
    message: messageEn,
    sidebar: sidebarEn,
    apiGovernance: apiGovernanceEn,
    PII: PIIEn,
    apiAdhocTesting: apiAdhocTestingEn,
    ruleMgmt: ruleMgmtEn,
    mockServer: mockServerEn,
    companyMgmt: companyMgmtEn,
    apiApplication: apiApplicationEn,
    datahubNew: datahubNewEn,
    apiForm: apiFormEn,
    comments: commentsEn,
    monitoring: monitoringEn,
    bugherd: bugherdEn,
  },
  vi: {
    translation: translationVi,
    common: commonVi,
    teams: teamsVi,
    workspace: workspaceVi,
    workSpaceDardboard: workSpaceDardboardVi,
    header: headerVi,
    message: messageVi,
    sidebar: sidebarVi,
    apiGovernance: apiGovernanceVi,
    PII: PIIVi,
    apiAdhocTesting: apiAdhocTestingVi,
    ruleMgmt: ruleMgmtVi,
    mockServer: mockServerVi,
    companyMgmt: companyMgmtVi,
    apiApplication: apiApplicationVi,
    datahubNew: datahubNewVi,
    apiForm: apiFormVi,
    comments: commentsVi,
    monitoring: monitoringVi,
    bugherd: bugherdVi,
  },
  hi: {
    translation: translationHi,
    common: commonHi,
    teams: teamsHi,
    workspace: workspaceHi,
    workSpaceDardboard: workSpaceDardboardHi,
    header: headerHi,
    message: messageHi,
    sidebar: sidebarHi,
    apiGovernance: apiGovernanceHi,
    PII: PIIHi,
    apiAdhocTesting: apiAdhocTestingHi,
    ruleMgmt: ruleMgmtHi,
    mockServer: mockServerHi,
    companyMgmt: companyMgmtHi,
    apiApplication: apiApplicationHi,
    datahubNew: datahubNewHi,
    apiForm: apiFormHi,
    comments: commentsHi,
    monitoring: monitoringHi,
    bugherd: bugherdHi,
  },
  es: {
    common: commonEs,
    companyMgmt: companyMgmtEs,
    header: headerEs,
    apiAdhocTesting: apiAdhocTestingEs,
    apiGovernance: apiGovernanceEs,
    PII: PIIEs,
    bugherd: bugherdEs,
  },
  ar: {
    common: commonAr,
    companyMgmt: companyMgmtAr,
    header: headerAr,
    apiAdhocTesting: apiAdhocTestingAr,
    apiGovernance: apiGovernanceAr,
    PII: PIIAr,
    bugherd: bugherdAr,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    lng: MULTI_LANGUAGE.ENG,
    fallbackLng: MULTI_LANGUAGE.ENG,
    supportedLngs: [
      MULTI_LANGUAGE.ENG,
      MULTI_LANGUAGE.VIT,
      MULTI_LANGUAGE.HIN,
      MULTI_LANGUAGE.ESP,
      MULTI_LANGUAGE.ARB,
    ],
    interpolation: {
      escapeValue: false,
    },
    defaultNS,
    react: {
      useSuspense: false,
    },
    ns,
    resources,
    fallbackNS: ns,
  });

export default i18n;
